import Container_LiftedTopAreaSkinComponent from '../components/Container/viewer/skinComps/LiftedTopAreaSkin/LiftedTopAreaSkin.skin';


const Container_LiftedTopAreaSkin = {
  component: Container_LiftedTopAreaSkinComponent
};


export const components = {
  ['Container_LiftedTopAreaSkin']: Container_LiftedTopAreaSkin
};

